//import axios from "axios";
import MenuUser from "@/components/users/MenuUser.vue";

export const chatbody ={  
  props:{
    chat_roomId:{},
    chatroomInfo:{},
    messages:{},
    admin_messages:{},
    isChat:{},
    ownerId:{},
    ckstate:{},  
    messageinput:{default:true} ,
    mtm_join:{}   
  },
  components:{
    MenuUser
  },
   data() {
    return {
      msg: "",
      ContextMenu:false,
      x:0,
      y:0,
      ContextMenuTop:'300px',
      ContextMenuLeft:'',
      senduser:'',
    };
  },
  // watch:{
  //   isMessageDelete(state){
  //     if(state)
  //     {
  //       alert('메세지 초기화'); 
  //       this.initMessage();               
  //     }     
  //   }
  // },
  computed: {
    switchMode() {
        // if ( (this.isChat && this.isAuth && this.chat_roomId === 'm1') || this.isManager || this.isOwner || this.chat_roomId.includes('mtm'))
        if ( (this.isAuth && this.chat_roomId === 'm1') || this.isManager || this.isOwner)
        {
          return "메세지 입력하기";
        }else if(!this.isAuth){
            return "로그인이 필요합니다.";
        }else if(!this.isOwner && this.chat_roomId !== 'm1'){
            //return "채팅이 잠겨 있습니다.";
            return "메세지 입력하기";
        }else{
            return "다른곳에서 접속하셨습니다.";
        }
    },
    isAuth() {
      return this.$store.getters.isAuthenticated;
    },
    user() {
      return this.$store.getters.currentUser;
    },
    isOwner(){
      return this.user.id === this.ownerId && this.ownerId >0;
    },
    isManager(){
      if(this.$store.state.chat.roomInfo)
      {
        return this.$store.state.chat.roomInfo.roomInfo.manager.find((manager) => manager.user_id === this.user.id);
      }else{
        return false;
      }      
    },
    isMessageDelete(){
      return this.$store.state.sets.clearChatMessages;
    },
    isClear(){
      return this.chatclear;
    }

  },

  mounted() {
    //this.fetchMessages();

    // Listen to all clicks on the document 일단 다른 방식으로 처리 참고용으로 남겨둠
    document.addEventListener("click", function(event)
    {
      // 해당 클래스 네임을 클릭시는 팝업을 띄움
      if( event.target.classList !='username' && event.target.closest(".messages-container"))//messages-container 부모영역일때만 클릭시 하이드
      {
        //alert(event.target.classList);
        this.ContextMenu = false;
      }
    }.bind(this));

  },
  updated(){
    this.updateScroll();
  },
  methods: {
    
    hideContextMenu(){
      this.ContextMenu = false;
    },
    updateCoordinates: function(event){
      this.x = event.clientX;
      this.y = event.clientY;
    },
     dummy: function(event)
    {
        event.stopPropagation();
    },
    viewMenu(event,user){
      this.senduser =user;
      this.ContextMenuTop = (event.clientY-10)+'px';
      this.ContextMenuLeft = (event.clientX-10)+'px';
      this.ContextMenu = true;
    },
    // async fetchMessages() {
    //      this.isLoading = true;
    //     try {
    //          const response = await axios.get("/api/chat/fetchmessages",{
    //             params:{
    //               room_id:this.chat_roomId
    //             }
    //            })
    //           console.log(response);
    //           this.messages = response.data.reverse();
    //     }catch(error){
    //         console.log(error.response);
    //     }
    //     this.isLoading = false;

    // //   axios.get("/api/v1/chat/fetchmessages").then((response) => {
    // //     this.messages = response.data;
    // //     this.updateScroll();
    // //   });

    // },
    sendMessage() {
      if (!this.msg) {
        alert('메세지를 입력해 주세요')
        return;
      }
      if(!this.isChat)
      {
        //this.messages.push({from:'Admin', text:'다른곳에서 접속하셨습니다.새로고침 하시면 재접속됩니다.', color:'red'});
        console.log('2중접속된곳에서 채팅 시도');
        //return false;
      }
      //로그인 회원만 가능 하게
        if(!this.isAuth)
        {
            let result = confirm("로그인이 필요합니다.");
            if(result){
                //this.$router

              
                this.$router.push({ name: 'auth_login'});
                return;
            }else{
                return;
            }
        }
      //아래는 잘 작동
      //axios.post("/api/v1/chat/sendMessage",{user_id: this.$store.getters.currentUser.id,message:this.msg})

    //   if(this.isLoggedIn){
    //         this.$store.dispatch("chat/sendMessage", {user_id: this.userId, message:this.msg, room_id:this.chat_roomId});
    //         this.messages.push({
    //         user: this.$store.getters.currentUser,
    //         message: this.msg
    //     })
    //   }else{
    //       alert('로그인 필요')
    //   }
      this.$store.dispatch("refreshExpire");
      this.$emit('sendmessage', this.msg);
      this.msg = "";
      this.updateScroll()
    },
    updateScroll(){
        var objDiv = document.getElementsByClassName("messages-container")[0]
        objDiv.scrollTop = objDiv.scrollHeight
    },    
  },
};